import { propClassName } from '@/styles/Factbox';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';
import { FactboxBodyComponent } from './Factbox.Body';
import { FactboxHeadlineComponent } from './Factbox.Headline';
import { FactboxImagesComponent } from './Factbox.Images';

export interface FactboxProps extends ComponentProps<'section'> {
  variant?: ClassNameProp<'default'>;
  size?: ClassNameProp<'default'>;
  colors?: ClassNameProp<'primary'>;
}

const FactboxComponent: Component<FactboxProps> = ({ children, className, variant, colors, size, ...props }) => {
  const variantClassName = propClassName('variant', variant, 'default');
  const sizeClassName = propClassName('size', size, 'default');
  const colorsClassName = propClassName('colors', colors, 'primary');

  const componentClassName = cn(variantClassName, colorsClassName, sizeClassName, className);

  return (
    <section className={componentClassName} {...props}>
      {children}
    </section>
  );
};

export const Factbox = Object.assign(FactboxComponent, {
  Headline: FactboxHeadlineComponent,
  Body: FactboxBodyComponent,
  Images: FactboxImagesComponent,
});
